<template>
    <div class="d-md-flex">
        <Sidebar :system="system"></Sidebar>
        <div id="content-wrapper" class="d-md-flex flex-column flex-grow-1">
            <!-- Main Content -->
            <div id="content" class="flex-grow-1">
                <!-- Topbar -->
                <TopNavbar></TopNavbar>
                <!-- End of Topbar -->
                <!-- Begin Page Content -->
                 <slot />
                <!-- /.container-fluid -->
            </div>
            <!-- End of Main Content -->
            <!-- Footer -->
            <Footer :system="system"></Footer>
            <!-- End of Footer -->
        </div>
    </div>
</template>

<script>
    import {defineAsyncComponent} from "vue";

    const Sidebar = defineAsyncComponent(() => import('./partial/Sidebar.vue'))
    const TopNavbar = defineAsyncComponent(() => import('./partial/Navbar.vue'))
    const Footer = defineAsyncComponent(() => import('./partial/Footer.vue'))

    export default {
        name: 'LayoutDashboard',
        components: {
            Sidebar,
            TopNavbar,
            Footer
        },
        computed: {
            system () {
                 return this.$store.state.system.settings;
            }
        },
    }
</script>
